import {
    REQUEST_REASONS,
    REQUEST_REASONS_SUCCESS,
    REQUEST_REASONS_FAILURE,
    START_REASON_CREATION,
    REASON_CREATION_SUCCESS,
    REASON_CREATION_FAILURE,
    START_REASON_EDITING,
    REASON_EDITING_SUCCESS,
    REASON_EDITING_FAILURE,
    REQUEST_DELETE_REASON,
    REASON_DELETE_SUCCESS,
    REASON_DELETE_FAILURE,
    SELECT_REASON,
    RESET_CURRENT_REASON,
    REQUEST_ADJUSTMENT_LOGS,
    ADJUSTMENT_LOG_SUCCESS,
    ADJUSTMENT_LOG_FAILURE,
} from "../actions/type";

const INITIAL_STATE = {
    reasons: [],
    isEditing: false,
    isLoading: false,
    isDeleting: false,
    createError: null,
    editingError: null,
    deletionError: null,
    logError: null,
    edited: false,
    created: false,
    deleted: false,
    error: null,
    reason: null,
    logs: [],
}

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case REQUEST_REASONS:
            return { ...state, isLoading: true, error: null };
        case REQUEST_REASONS_SUCCESS:
            return { ...state, reasons: action.payload.data, isLoading: false, error: null };
        case REQUEST_REASONS_FAILURE:
            const requestError = action.payload || {message: action.payload.message};
            return { ...state, error: requestError, reasons: [], isLoading: false }
        case START_REASON_CREATION: 
            return {...state, isLoading: true, error: null, createError: null, created: false}
        case REASON_CREATION_SUCCESS:
            return {...state, isLoading: false, createError: null, error: null, created: true}
        case REASON_CREATION_FAILURE:
            const creationError = action.payload || {message: action.payload.message};
            return {...state, isLoading: false, createError: creationError, created: false}
        case START_REASON_EDITING:
            return {...state, isEditing: true, editingError: null, edited: false}
        case REASON_EDITING_SUCCESS:
            return {...state, isEditing: false, editingError: null, edited: true}
        case REASON_EDITING_FAILURE:
            const editingError = action.payload || {message: action.payload.message}
            return {...state, isEditing: false, editingError: editingError, edited: false}
        case REQUEST_DELETE_REASON:
            return {...state, isDeleting: true, deleted: false, deletionError: null }
        case REASON_DELETE_SUCCESS:
            return {...state, isDeleting: false, deleted: true, deletionError: null }
        case REASON_DELETE_FAILURE:
            const deletionError = action.payload || {message: action.payload.message }
            return { ...state, isDeleting: false, deleted: false, deletionError: deletionError }
        case SELECT_REASON: 
            return {...state, reason: action.payload};
        case RESET_CURRENT_REASON:
            return {...state, reason: null};
        case REQUEST_ADJUSTMENT_LOGS:
            return {...state, logs: null, logError: null, isLoading: true};
        case ADJUSTMENT_LOG_SUCCESS:
            return {...state, logs: action.payload.data, logError: null, isLoading: false};
        case ADJUSTMENT_LOG_FAILURE:
            const logError = action.payload || {message: action.payload.message}
            return {...state, logs: [], logError: logError, isLoading: false}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./master/jsx/reducers/adjustmentInventory_reducer.js